import { forwardRef, useState } from "react"
import AsyncReactSelect from "react-select/async"

import { AsyncSelectProps, OptionType } from "./AsyncSelectProps"

const AsyncSelect = (
  {
    name,
    onChange,
    disabled,
    loadOptions,
    placeholder = "---",
    error = false,
    styles = {},
    defaultOptions,
    value,
    ...restProps
  }: AsyncSelectProps,
  ref: any,
) => {
  const [tempOptions, setTempOptions] = useState<OptionType[]>([])

  const border = `solid 1px ${error ? "#ff1923" : "#e5e5e5"}`

  const selectStyles: any = {
    control: (state: any) => ({
      ...state,
      backgroundColor: `${disabled ? "rgb(241, 243, 243);" : "white"}`,
      border,
      borderRadius: "2px",
      height: "36px",
      minHeight: "36px",
      boxShadow: "0 0 0 1px transparent",
      ":hover": {
        border,
        boxShadow: "0 0 0 1px transparent",
      },
      ":focus": {
        border,
        boxShadow: "0 0 0 1px transparent",
      },
    }),
    valueContainer: (state: any) => ({
      ...state,
      height: "36px",
      padding: "0 6px",
    }),
    input: (state: any) => ({
      ...state,
      margin: "0px",
    }),
    indicatorSeparator: (state: any) => ({
      ...state,
      display: "none",
    }),
    option: (state: any, { isDisabled }: any) => {
      const optStyles = {
        ...state,
        backgroundColor: "white",
        color: "#323237",
        ":hover": {
          backgroundColor: "rgba(0, 215, 255, 0.15)",
        },
      }

      if (isDisabled) {
        optStyles.cursor = "not-allowed"
        optStyles.color = "#b9bcbf"
        optStyles[":hover"] = {}
      }

      return optStyles
    },
    menuPortal: (state: any) => ({ ...state, zIndex: 9999 }),
    indicatorsContainer: (state: any) => ({
      ...state,
      height: "36px",
    }),
  }

  let transformedValue = null
  if (Array.isArray(value)) {
    transformedValue = tempOptions?.filter((opt) => value?.includes(opt.value))
  } else {
    transformedValue = tempOptions?.find((opt) => opt.value === value)
  }

  const handleOnChange = (newValue: any, e: any) => {
    let transformedValue = null
    if (Array.isArray(newValue)) {
      transformedValue = newValue?.map((opt: any) => opt.value)
    } else {
      transformedValue = newValue?.value
    }

    onChange && onChange(transformedValue, e)
  }

  const handleLoadOptions = async (input: any) => {
    const options = await loadOptions(input)
    setTempOptions(options)
    return options
  }

  return (
    <div data-name={name}>
      <AsyncReactSelect
        ref={ref}
        classNamePrefix="react-async-select"
        styles={{ ...selectStyles, ...styles }}
        loadOptions={handleLoadOptions}
        placeholder={placeholder}
        isDisabled={disabled}
        name={name}
        value={transformedValue}
        defaultOptions={tempOptions}
        menuPortalTarget={document.body}
        onChange={handleOnChange}
        {...restProps}
      />
    </div>
  )
}

export default forwardRef(AsyncSelect)
